export const ChevronUpIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:chevron-up">
			<path
				id="Vector"
				d="M17.4999 15.914L11.9999 10.414L6.49994 15.914L5.08594 14.5L11.9999 7.586L18.9139 14.5L17.4999 15.914Z"
				fill="#22082B"
			/>
		</g>
	</svg>
);
